<template lang="html">
  <v-page class="page-terms">
    <v-container>
      <v-row class="justify-content-center">
        <v-col :md="9">
          <v-logo />

          <span v-html="privacy_template.template"></span>
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
import publicApi from '@/api/public';
import apiClient from '@/api/client';
import apiVibbrante from '@/api/vibbrante';

export default {
  props: {
    profile: String,
    privacy_template: {},
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.profile === 'vibbrant') {
        apiVibbrante
          .vibbranteGetSignedContract(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              response.data.forEach(element => {
                if (element.apply_to.includes('privacy')) {
                  this.privacy_template = element;
                }
              });
            }
          });
      } else if (this.profile === 'client') {
        apiClient
          .clientGetSignedContract(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              response.data.forEach(element => {
                if (element.apply_to.includes('privacy')) {
                  this.privacy_template = element;
                }
              });
            }
          });
      } else {
        publicApi
          .privacy()
          .then(response => {
            this.privacy_template = response.data;
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
  },
};
</script>

<style lang="scss">
.terms-text {
  font-size: 0.9em;
  h1 {
    font-size: 1.8em;
  }
  h2 {
    font-size: 1.6em;
  }
}
.page-terms {
  .logo {
    width: 200px;
    margin: 0 auto 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/privacy.vue